import { CustomerMethodologyPage } from "../../components/CustomerMethodologyPage";

export function LicensingMethodology() {
  return (
    <CustomerMethodologyPage
      title="Pharmacist licensing — overview"
      description="How WeConsult Rx tracks consultant pharmacist licenses, CE requirements, and renewal deadlines."
      path="/trust/licensing-methodology"
    >
      <p>
        The licensing module tracks consultant pharmacist licenses across
        states, continuing education requirements, and renewal deadlines with
        automated reminders.
      </p>
      <h2>What it covers</h2>
      <ul>
        <li>Multi-state license tracking with expiration dates.</li>
        <li>Continuing education requirement mapping by state.</li>
        <li>Renewal reminders at 90, 30, and expired intervals.</li>
      </ul>
      <h2>How it helps</h2>
      <p>
        Practice administrators avoid missed renewals and can demonstrate
        current licensure during facility onboarding or survey.
      </p>
    </CustomerMethodologyPage>
  );
}
